import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMapPin, FiArrowRight } from 'react-icons/fi';
import { generateSlug } from '../utils/slugify';
import { getImageUrl } from '../utils/imageUtils';
import './ProjectCard.css';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const isWealth = project.isWealthProject;
  
  let imgUrl = 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80';
  if (isWealth && project.photo) {
    imgUrl = project.newImageUrl || (project.photo.startsWith('http') ? project.photo : getImageUrl(project.photo, true));
  } else if (!isWealth && project.projectImage) {
    imgUrl = getImageUrl(project.projectImage);
  }

  const logoUrl = !isWealth && project.projectLogo ? getImageUrl(project.projectLogo) : null;
  const title = isWealth ? (project.projectName || project.officeAddress || project.companyName) : project.title;
  const builderName = isWealth ? project.companyName : project.builderName;
  const locationText = isWealth ? (project.projectAddress || project.city) : `${project.address?.line1 ? `${project.address.line1}, ` : ''}${project.address?.city || ''}`;
  const projectLink = isWealth 
    ? `/wealth-project/${generateSlug(title || 'project')}/${project._id}`
    : `/project/${generateSlug(title || 'project')}/${project._id}`;

  const handleProfileClick = (e) => {
    e.stopPropagation();
    if (!isWealth && project.postedBy) {
      const posterId = typeof project.postedBy === 'object' ? project.postedBy._id : project.postedBy;
      navigate(`/profile/builder/${posterId}/${generateSlug(builderName || 'builder')}`);
    }
  };

  return (
    <div 
      className="premium-card cursor-pointer group"
      onClick={() => navigate(projectLink)}
    >
      <div className="premium-card-img-wrapper">
        {project.projectType && (
          <div className="badge-bottom-left">
            <span className="glass-badge primary">{project.projectType}</span>
          </div>
        )}
        {project.projectStatus && (
          <div className="badge-bottom-right">
            <span className="glass-badge">{project.projectStatus}</span>
          </div>
        )}
        
        <img 
          src={imgError ? 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80' : imgUrl} 
          onError={() => setImgError(true)} 
          alt={project.title} 
          className="premium-card-img" 
        />
        <div className="premium-card-img-overlay"></div>
      </div>
      
      <div className="premium-card-content">
        <h3 className="premium-title">
          {title || 'Untitled Project'}
        </h3>
        
        <p className="premium-location">
          <FiMapPin style={{ color: 'var(--primary-color)', flexShrink: 0 }} size={16} /> 
          <span>{locationText}</span>
        </p>
        
        {project.projectType === 'Plots / Land' ? (
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
            {project.extent && (
              <span className="config-tag" style={{ background: '#fef3c7', color: '#b45309', border: 'none' }}>
                Extent: {project.extent}
              </span>
            )}
            {project.totalPlots && (
              <span className="config-tag" style={{ background: '#e0e7ff', color: '#4338ca', border: 'none' }}>
                Plots: {project.totalPlots}
              </span>
            )}
          </div>
        ) : project.bedrooms && project.bedrooms !== 'N/A' && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '4px' }}>
            {project.bedrooms.split(',').map((config, idx) => (
              <span key={idx} className="config-tag">
                {config.trim()}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="premium-footer">
        <div 
          className="flex items-center cursor-pointer"
          style={{ gap: '12px' }}
          onClick={handleProfileClick}
          title={`View ${project.builderName}'s Profile`}
        >
          <div className="builder-avatar">
            {logoUrl && !logoError ? (
              <img 
                src={logoUrl} 
                onError={() => setLogoError(true)} 
                alt={project.builderName} 
                style={{ width: '100%', height: '100%', objectFit: 'contain', backgroundColor: 'white' }} 
              />
            ) : (
              <span>{project.builderName ? project.builderName.charAt(0).toUpperCase() : 'B'}</span>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>Developed By</span>
            <span style={{ fontSize: '14px', fontWeight: 800, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '140px', transition: 'color 0.3s' }} className="group-hover:text-primary">
              {builderName || 'Unknown Builder'}
            </span>
          </div>
        </div>
        <div className="action-arrow">
          <FiArrowRight size={14} />
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
